var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('StartupsHeader'),_c('Search',{attrs:{"search-type":"startups","old-search":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }